// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2aOFT","emails":"CreateEditClinics_emails__1yTOp","emailTagLabel":"CreateEditClinics_emailTagLabel__9PTw-"};